import { observer } from 'mobx-react';
import { forwardRef, useImperativeHandle } from 'react';
import { NewsLegend } from '../../../../../components/Module/Legend/NewsLegend';
import { useNewsContext } from './context';

interface MapWidgetNewsLegendItemRef {
  remove(): void;
}

export const MapWidgetNewsLegendItem = forwardRef<MapWidgetNewsLegendItemRef>(
  (_, ref) => {
    const { layerLoader } = useNewsContext();

    useImperativeHandle(ref, () => ({
      remove: () => {
        if (layerLoader.isVisible) {
          layerLoader.hide();
        }
      },
    }));

    return <BaseLegendItem />;
  },
);

const BaseLegendItem = observer(() => {
  const { layerLoader } = useNewsContext();

  if (!layerLoader.isVisible) return null;

  return (
    <NewsLegend
      total={layerLoader.count || 0}
      isLoading={layerLoader.isLoading}
      error={layerLoader.error}
    />
  );
});
